var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliatemedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.3 6.86.54.54c.43.42.66.99.66 1.59a2.23 2.23 0 0 1-.66 1.61l-.54.54c-.21.21-.33.5-.33.8v.77a2.26 2.26 0 0 1-2.26 2.26h-.77c-.3 0-.59.12-.8.33l-.54.54a2.27 2.27 0 0 1-3.2 0l-.54-.54c-.21-.21-.5-.33-.8-.33H5.3a2.26 2.26 0 0 1-2.26-2.26v-.77c0-.3-.12-.59-.33-.8l-.54-.54a2.27 2.27 0 0 1 0-3.2l.54-.54c.21-.21.33-.5.33-.8v-.77A2.26 2.26 0 0 1 5.3 3.03h.77c.3 0 .59-.12.8-.33l.54-.54a2.26 2.26 0 0 1 3.2 0l.54.54c.21.21.5.33.8.33h.77a2.26 2.26 0 0 1 2.26 2.26v.77c0 .3.12.59.33.8Zm-8.23 4.72c.18 0 .34-.06.46-.2l3.86-3.85a.66.66 0 0 0 0-.93.65.65 0 0 0-.92 0L6.6 10.46a.66.66 0 0 0 .46 1.12Zm3.2-.66a.66.66 0 1 0 1.32.01.66.66 0 0 0-1.32 0Zm-3.2-4.5a.65.65 0 1 1 0 1.31.66.66 0 0 1-.65-.66c0-.36.3-.65.66-.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliatemedium);
export default __webpack_public_path__ + "static/media/affiliate.medium.3aafdffe7b11ba92745259e7e14aabdc.svg";
export { ForwardRef as ReactComponent };